var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCamtasiaWebLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  className: "CamtasiaWebLogo_svg__sc-lbxAil CamtasiaWebLogo_svg__gFonQY",
  viewBox: "0 0 32 32"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  fill: "url(#CamtasiaWebLogo_svg__a)",
  rx: 7
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  clipPath: "url(#CamtasiaWebLogo_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.85 6.118 7 10h13.431a.4.4 0 0 0 .278-.118l3.174-3.198a.4.4 0 0 0 .088-.432.41.41 0 0 0-.366-.252H11.13a.4.4 0 0 0-.28.118m0 19.764L7 22h13.431a.4.4 0 0 1 .278.118l3.174 3.199a.4.4 0 0 1 .088.43.41.41 0 0 1-.366.253H11.13a.4.4 0 0 1-.278-.118"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11 10H7v12h4z",
  opacity: 0.74
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "CamtasiaWebLogo_svg__a",
  x1: 0,
  x2: 0,
  y1: 0,
  y2: 32,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#97C93D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3D9544"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "CamtasiaWebLogo_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M7 6h17v20H7z"
})))));
export default SvgCamtasiaWebLogo;